// Keys used for local storage.
export const SESSION_KEY = 'auth_session';
export const STATE_KEY = 'google_auth';
export const AGE_ANTISPOOFING_CONFIG_KEY = 'age_antispoofing_config';
export const FACE_MATCHING_CONFIG_KEY = 'face_matching_config';
export const SCAN_FIRST_LANDING_CONFIG_KEY = 'scan_first_landing_config';
export const FACE_MATCHING_FIRST_LANDING_CONFIG_KEY = 'face_matching_first_landing_config';
